import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { IOnboardingTipsService } from '../../services/onboarding-tips/onboarding-tips.interface';
import { OnboardingTipsConstant } from './onboarding-tips.constant';

@Component({
  selector: 'gtd-onboarding-tips',
  templateUrl: './onboarding-tips.modal.html',
})
export class OnboardingTipsModal implements AfterViewInit {
  public currentPageKey: string;
  public isVisible: boolean;
  public isShowTips: boolean;
  public activeTip = 0;
  public OnboardingTipsConstant = OnboardingTipsConstant;
  public offsetTop: number;
  public offsetRight: number;

  constructor(
    @Inject('IOnboardingTipsService') private onboardingTipsService: IOnboardingTipsService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.router.events.subscribe(() => {
      this.isShowTips = false;
      this.activeTip = 0;
      if (this.currentPageKey === 'smartLinks') {
        this.onboardingTipsService.changeStateTips(this.currentPageKey, 'create', false);
      }
      if (this.currentPageKey === 'reports') {
        this.onboardingTipsService.changeStateTips('reports', 'create', true);
      }
      if (this.currentPageKey === 'drilldown') {
        this.onboardingTipsService.changeStateTips(this.currentPageKey, 'create', false);
      }
    });
  }

  ngAfterViewInit() {
    if (this.onboardingTipsService.getPageStatus() && this.onboardingTipsService.getWorkingStatus()) {
      this.isVisible = true;
      this.cdr.detectChanges();
    }

    this.onboardingTipsService.stateChanges().subscribe(() => {
      this.currentPageKey = this.onboardingTipsService.getCurrentPageKey();
      this.isVisible =
        this.onboardingTipsService.getWorkingStatus() &&
        this.currentPageKey &&
        this.onboardingTipsService.checkCurrentPage(this.currentPageKey);
      this.offsetTop = this.onboardingTipsService.getOffsetTopModal();
      this.offsetRight = this.onboardingTipsService.getOffsetRightModal();
      this.cdr.detectChanges();
    });
  }

  close(): void {
    this.isVisible = false;
    this.isShowTips = false;
    this.onboardingTipsService.changeState(this.onboardingTipsService.getCurrentPageKey(), false);
    this.closeTipsWithNames();
  }

  showTips(): void {
    this.isShowTips = true;
    if (this.currentPageKey === 'reports') {
      this.onboardingTipsService.changeStateTips('reports', 'create', false);
    }
    this.manageTipsWithNames();
  }

  previousTip(): void {
    if (this.activeTip > 0) {
      this.activeTip--;
      this.manageTipsWithNames();
    } else {
      this.isShowTips = false;
    }
  }

  nextTip(): void {
    this.activeTip++;
    this.manageTipsWithNames();
  }

  changeTip(tipIndex: number): void {
    this.activeTip = tipIndex;
    this.manageTipsWithNames();
  }

  manageTipsWithNames() {
    const tipNames = OnboardingTipsConstant[this.currentPageKey.toUpperCase()]?.tipNames;

    if (tipNames) {
      this.onboardingTipsService.changeStateTips(this.currentPageKey, tipNames[this.activeTip], true);
    }
  }

  closeTipsWithNames() {
    const tipNames = OnboardingTipsConstant[this.currentPageKey.toUpperCase()]?.tipNames;
    if (tipNames) {
      this.onboardingTipsService.changeStateTips(this.currentPageKey, tipNames[this.activeTip], false);
    }
    this.activeTip = 0;
  }
}
